const urlParams = new URLSearchParams(window.location.search);

const projectId = urlParams.get('id');
const fromExcom = urlParams.get('ex');

export { projectId, fromExcom };
